import { Card, Col, Row } from "react-bootstrap";
import { TbCoins, TbTruckDelivery } from "react-icons/tb";
import DetailedList from "../../shared/DetailedList";
import { FaSwimmingPool } from "react-icons/fa";
import { useEffect, useState } from "react";
import PdfModal from "../../shared/PdfModal";
import { useParams } from "react-router-dom";

const DocumentsCard = ({abrechnungen, vorschreibungen, poolrechnungen}) => {

    const [showPDFViewModal, setShowPDFViewModal] = useState(false);
    const [base64PDF, setBase64PDF] = useState("");
    const iconsSize = 30;

    const { type, doc_id } = useParams();

    const viewPDFHandler = (b64) => {
        setBase64PDF(b64);
        setShowPDFViewModal(true);
    }

    useEffect(() => {
        if (type && doc_id) {

        }
    }, [type, doc_id])

    return (
        <>
            <Card className="radius-20 shadow-lg">
                <Card.Body>
                    <h5>Dokumente</h5>
                    <Row className="mt-3">
                        <Col>
                            <div className="mb-5">
                                <div className="documents-header bg-primary">
                                    <TbTruckDelivery size={iconsSize} /> Energielieferant
                                </div>
                                <DetailedList key="abrList" data={abrechnungen} type="abrechnung" pdfReader={viewPDFHandler} preselect={type === "abrechnung"? {type: type, id: Number(doc_id)}: null} />
                            </div>
                            <div className="mb-5">
                                <div className="documents-header bg-warning">
                                    <TbCoins size={iconsSize} /> Vorschreibungen
                                </div>
                                <DetailedList key="vorList" data={vorschreibungen} type="vorschreibung" pdfReader={viewPDFHandler} preselect={type === "vorschreibung"? {type: type, id: Number(doc_id)}: null} />
                            </div>
                            <div className="mb-5">
                                <div className="documents-header bg-energo">
                                    <FaSwimmingPool size={iconsSize} /> ENERGO
                                </div>
                                <DetailedList key="poolList" data={poolrechnungen} type="poolrechnung" pdfReader={viewPDFHandler} preselect={type === "poolrechnung"? {type: type, id: Number(doc_id)}: null} />
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <PdfModal show={showPDFViewModal} setShow={setShowPDFViewModal} file={base64PDF} />
        </>
    )
}
export default DocumentsCard;